/**
 * 355: Malaysia-time labels. Malaysia is a fixed +08:00 with no daylight saving, and staff read every time in it,
 * whatever zone the browser is in.
 */
const ZONE = 'Asia/Kuala_Lumpur';

const clock = new Intl.DateTimeFormat('en-GB', {
  timeZone: ZONE,
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});
const dayLabel = new Intl.DateTimeFormat('en-GB', {
  timeZone: ZONE,
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

/** `20:58`. */
export function mytClock(iso: string | Date): string {
  return clock.format(new Date(iso));
}

/** `Sunday, 4 October 2026`. */
export function mytDayLabel(iso: string | Date): string {
  const parts = Object.fromEntries(
    dayLabel.formatToParts(new Date(iso)).map((p) => [p.type, p.value]),
  );
  return `${parts.weekday}, ${parts.day} ${parts.month} ${parts.year}`;
}

const inputParts = new Intl.DateTimeFormat('en-CA', {
  timeZone: ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/** 389: an instant as a `datetime-local` value in Malaysia time (`2026-10-20T00:00`), whatever the browser's zone. */
export function mytInputValue(iso: string | Date | null): string {
  if (!iso) return '';
  const p = Object.fromEntries(
    inputParts.formatToParts(new Date(iso)).map((x) => [x.type, x.value]),
  );
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
}

/** 389: a `datetime-local` value read as Malaysia time, as an ISO instant; null when empty or not a date. */
export function fromMytInput(value: string): string | null {
  if (!value) return null;
  const d = new Date(`${value}:00+08:00`);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}
